import React from 'react';
import {
  Box,
  Popover,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { ReactComponent as ArrowDropDownIcon } from 'src/icons/arrowDropDown.svg';
import palette from 'src/theme/palette';

import {
  DropdownButton,
  FilterMetricsInputWrapper,
  filterMetricsInputWrapperStyles,
  popoverStyles,
} from '../styled';
import { FilterProps } from '../types';

import { FilterCollapse } from './FilterCollapse';

export const FilterMetrics = ({ filter, formulaItemIndex }: FilterProps) => {
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen((previousOpen) => !previousOpen);
  };

  return (
    <Box>
      <Box onClick={(e) => handleClick(e)}>
        <FilterMetricsInputWrapper sx={filterMetricsInputWrapperStyles(open)}>
          <Typography
            fontSize="16px"
            lineHeight="21px"
            fontWeight={600}
            whiteSpace="nowrap"
          >
            {filter.label}
          </Typography>
          <DropdownButton>
            <ArrowDropDownIcon
              color={open ? palette.primary.contrastText : palette.grey[800]}
              height={24}
              width={24}
            />
          </DropdownButton>
        </FilterMetricsInputWrapper>
      </Box>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setOpen(false)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        slotProps={{ paper: { sx: popoverStyles(isSmallScreen) } }}
      >
        <FilterCollapse filter={filter} formulaItemIndex={formulaItemIndex} />
      </Popover>
    </Box>
  );
};
